import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, VariableType, DigitalSet, ConnectionPoint, TagDefinition, ImportedTagDefinition } from '../../../models';
import { IRootScope } from '../../../IRootScope';
import { ItagsImportService, IStoreService, ISaveMessagesService } from '../../../services';
import { toggleEditMode } from '../../../common';
import { StoreElement } from '../../../stateManagement';
import { IGroupTagsControllerScope } from '../../../components';

class TagsImportStateController implements angular.IComponentController {
    isLoaded: boolean = false;
    beginDate: string;
    connectionPoints: ConnectionPoint[] = [];
    digitalSets: DigitalSet[] = [];
    displayed: any[];
    endDate: string;
    formController: angular.xeditable.IEditableFormController;
    groupTagsScope: IGroupTagsControllerScope;
    importAliasCallback: (extras) => void;
    initialRange: any;
    proposedAlias: any;
    selectedItem: TagDefinition;
    tags: TagDefinition[];
    variables: VariableType[];

    private _importingTag: any;
    private _unsubscribe: Function;

    static $inject = [
        '$q',
        '$rootScope',
        'tagsImportService',
        'storeService',
        'saveMessagesService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _$rootScope: IRootScope,
        private _tagsImportService: ItagsImportService,
        private _storeService: IStoreService,
        private _saveMessagesService: ISaveMessagesService
    ) {
    }

    $onInit() {
        this._unsubscribe = this._storeService.register(store => {
            this.digitalSets = _.values(store.digitalSets.dictionary);
            this.variables = _.values(store.variablesTypes.dictionary);
            this.connectionPoints = _.values(store.connectionPoints.dictionary);
            this.tags = _.values(store.tags.dictionary);
            this.isLoaded = store.digitalSets.isLoaded && store.variablesTypes.isLoaded && store.connectionPoints.isLoaded && store.tags.isLoaded;
        }, [StoreElement.DigitalSets, StoreElement.Variables, StoreElement.ConnectionPoints]);

        if (!this._$rootScope.isEditMode) {
            this._$rootScope.$broadcast(toggleEditMode);
        }

        this.importAliasCallback = (extraList) => {
            this.startImport(extraList);
        };
    }

    $onDestroy() {
        this._unsubscribe();
    }

    onSave() {
        const p = this._storeService.dispatchers().tags
            .update([this.selectedItem])
            .then(data => {
                this.groupTagsScope.refresh();
                return data;
            });
        return this._saveMessagesService.saveTag(p);
    }

    onCancel() {
        this.selectedItem = null;
    }

    /*
     * Called to import a group of tags, but we must check units first to create alias on-the-fly
     */
    importAll(): angular.IPromise<string[]> {
        const defered = this._$q.defer<string[]>();
        this._importingTag = null;
        this._tagsImportService
            .searchUnknownUnits(this.displayed.filter(t => !t.isAlreadyExisting))
            .then(data => {
                if (data && data.length > 0) {
                    this.proposedAlias = data.map(d => { return { name: d, save: true, }; });
                    $('#aliasModal').modal('show');
                    this.formController.$show();
                } else {
                    this.startImport([]);
                }
                defered.resolve(data);
            }).catch(reason => {
                defered.reject(reason);
            });

        return defered.promise;
    }

    import(tagImport: ImportedTagDefinition) {
        const defered = this._$q.defer();
        this._importingTag = tagImport;

        this._tagsImportService
            .searchUnknownUnits([tagImport])
            .then(data => {
                if (data && data.length > 0) {
                    this.proposedAlias = data.map(d => { return { name: d, save: true, }; });

                    $('#aliasModal').modal('show');
                    this.formController.$show();
                } else {
                    this.startImport([]);
                }
                defered.resolve(tagImport);
            }).catch(reason => {
                defered.reject(reason);
            });

        return defered.promise;
    }

    // force refresh of store when sub component has added manually, yek
    groupTagsOnAdd() {
        this._storeService.dispatchers().tags.getAll(true);
        this._storeService.dispatchers().valueViewModels.getAll(true);
    }

    startImport(tempAliasList: any): angular.IPromise<any> {
        const promise = this._importingTag
            ? this.startImportOne(tempAliasList)
            : this.startImportAll(tempAliasList);
        let retval: any;
        return promise
            .then(data => {
                retval = data;
                return this._$q.all([
                    this._storeService.dispatchers().tags.getAll(true),
                    this._storeService.dispatchers().valueViewModels.getAll(true)
                ]);
            })
            .then(data => {
                return retval;
            });
    }

    startImportOne(tempAliasList: any): angular.IPromise<any> {
        return this._tagsImportService.import(this._importingTag, tempAliasList);
    }

    startImportAll(tempAliasList: any): angular.IPromise<any> {
        return this._tagsImportService.importAll(tempAliasList, this.displayed);
    }

    getCountNew(results): number {
        return results.filter(t => !t.isAlreadyExisting).length;
    }

    displayedCount() {
        return !!this.displayed
            ? this.displayed.filter(t => !t.isAlreadyExisting).length
            : 0;
    }
}

export const wtTagsImportState: ComponentDefinition = {
    componentId: 'wtTagsImportState',
    controller: TagsImportStateController,
    template: require('./tagsImportState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
